import {BasicData, DropdownData} from '@graphql/fragments';

export const optionsOriginEntryPoints = `
query optionsUdpEntryPointsQuery(
  $encodingDatacentersForUpd: [ID],
  $encodingDatacentersForSdi: [ID]
) {
  udpOriginEntryPoints(filters: {encodingDatacenter: $encodingDatacentersForUpd}) {
    key: id
    value: id
    text: name
    url
    content_categories {id}
    tournaments {id name}
  }
  sdiOriginEntryPoints(filters: {encodingDatacenter: $encodingDatacentersForSdi}) {
    key: id
    value: id
    text: name
  }
}
`;
export const optionsContactPersonsAndOriginStreamName = `
query optionsContactPersonsAndOriginStreamNameQuery($productionCompany: ID) {
  contactPersons(filters: {productionCompany: $productionCompany}) {
    key: id
    value: id
    text: name
  }
  rtmpOriginStreamNames(filters:{productionCompany:$productionCompany, isArchived: false}) {
    key: id
    value: id
    text: name
  }
}
`;

export const propertyLicenceTechSetupProducts = `
query PropertyLicenceTechSetupProductsQuery($propertyLicenceTechSetup: Int) {
  propertyLicenceTechSetupProducts(filters: {propertyLicenceTechSetup: $propertyLicenceTechSetup}) {
    product {
      id
      name
    }
    product_status {
      id
      name
    }
    property_licence_tech_setup {
      contribution_type {id}
      encoding_datacenter {id}
      origin_stream_type {id}
    }
  }
}
`;
export const srtOriginEntryPointsForDropdown = `
query GetSrtOriginEntryPoints {
  srtOriginEntryPoints {
    ${DropdownData}
    url
    content_categories {
        id
    }
    tournaments {
        ${BasicData}
    }
  }
}
`;
